export default "__VITE_ASSET__CvKJOX8J__"